module.exports = __webpack_public_path__ + "img/customer-support.9b6ba3b8.svg";